<div class="modal-header">
    <h4 class="modal-title fw-bold">
        <span>{{ title }}</span>
    </h4>
    <button (click)="dismiss()" aria-hidden="true" class="btn-close" data-bs-dismiss="modal"
            type="button">
    </button>
</div>
<div class="modal-body">
    <div>
        <span>{{ titleTable }}</span>
    </div>
    <br>
    <div class="table-responsive custom-scroll-style" style="max-height: 560px; overflow: auto">
        <table class="table table-striped table-bordered table-curved">
            <thead>
            <th>
                <span jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.observation.table.header.observation.no"></span>
            </th>
            <th>
                <span jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.observation.table.header.no"></span>
            </th>
            <th>
                <span jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.observation.table.header.gid"></span>
            </th>
            <th *jhiHasAnyAuthority="VIEW_NAMES_PERMISSIONS">
                <span jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.observation.table.header.designation"></span>
            </th>
            <ng-container *ngIf="locationHeader.length > 0">
                <ng-container *ngFor="let locationName of locationHeader">
                    <th>
                        <span>{{ locationName }}</span>
                    </th>
                </ng-container>
            </ng-container>
            </thead>
            <tbody *ngIf="traitObs?.length else nodata">
            <tr *ngFor="let obs of traitObs trackBy: trackId; index as index">
                <td>{{ calculateObsNumber(index) }}</td>
                <td>{{ obs.lineNo }}</td>
                <td>
                    <a [href]="this.germplasmDetailsUrlService.getUrl(obs.gid)" class="link"
                       target="_blank">
                        <truncate-span [textInput]="obs.gid">
                        </truncate-span>
                    </a>
                </td>
                <td *jhiHasAnyAuthority="VIEW_NAMES_PERMISSIONS">
                    <a [href]="this.germplasmDetailsUrlService.getUrl(obs.gid)" class="link"
                       target="_blank">
                        <truncate-span [textInput]="obs.designation">
                        </truncate-span>
                    </a>
                </td>
                <ng-container *ngFor="let locationName of locationHeader ">
                    <td>{{ obs.locationName === locationName ? obs.value : '' }}</td>
                </ng-container>
            </tr>
            </tbody>
        </table>
        <ng-template #nodata>
            <tbody>
            <tr>
                <td [attr.colspan]="colspan()" jhiTranslate="no.data"></td>
            </tr>
            </tbody>
        </ng-template>
    </div>
    <div *ngIf="traitObs && traitObs.length">
        <div class="row">
            <div class="col">
                <div class="pagination-container">
                    <div class="pagination-box pagination-box-left">
                        <div>
                            <jhi-item-count [page]="page" [total]="totalItems" [itemsPerPage]="itemsPerPage"></jhi-item-count>
                        </div>
                    </div>
                    <div class="pagination-box">
                        <ngb-pagination [collectionSize]="totalItems" [(page)]="page" [pageSize]="itemsPerPage" [disabled]="isLoading"
                                        [maxSize]="5" [rotate]="true" [boundaryLinks]="true" (pageChange)="loadPage(page)"></ngb-pagination>
                    </div>
                    <div class="pagination-box pagination-box-right">
                        <div class="d-flex align-items-center">
                            <label class="control-label control-label-left" for="itemsPerPage" jhiTranslate="global.items.per.page">Items Per
                                Page</label>
                            <select (change)="resetTable();" [(ngModel)]="itemsPerPage" [disabled]="isLoading"
                                    class="form-select ms-2" id="itemsPerPage" style="width:95px">
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="75">75</option>
                                <option value="100">100</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
